import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/notifications')({
  component: RouteComponent,
  beforeLoad: () => ({
    getTitle: () => 'Notifications',
  }),
});

function RouteComponent() {
  return <div />;
}
